// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
// import {
//     getPageLinkByNodeId,
//     LinkModel,
//     useGetLink,
//     useGetLinks,
// } from "@insite/client-framework/Store/Links/LinksSelectors"; // Store Custom Code
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { useMergeStyles } from "@insite/content-library/additionalStyles";
// import Link from "@insite/mobius/Link"; // Starter Custom Code
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
// import InjectableCss from "@insite/mobius/utilities/InjectableCss"; // Starter Custom Code
import * as cssLinter from "css";
import * as React from "react";
import { FC } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Starter Custom Code - End */

// Foundation --->
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import fieldDefinitionBuilder from "@store/Framework/Features/FieldDefinitionBuilder/fieldDefinitionBuilder";
import { HasResponsive } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";
import { responsiveCss } from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/responsiveCss";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Foundation

/* Store Custom Code - Start */
import { getPageLinkByNodeId, LinkModel, useGetLink, useGetLinks } from "@store/Framework/Store/Links/LinksSelectors";
/* Store Custom Code - End */

// Store Custom Code
const enum fields {
    direction = "direction",
    alignment = "alignment",
    title = "title",
    titleLink = "titleLink",
    links = "links",
    customCSS = "customCSS",
    // Foundation
    useCustomTextColor = "useCustomTextColor",
    textColor = "textColor",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.direction]: "vertical" | "horizontal";
        [fields.alignment]: "left" | "center" | "right";
        [fields.title]: string;
        [fields.titleLink]: LinkFieldValue;
        [fields.links]: LinkModel[];
        [fields.customCSS]: string;
        // Foundation
        [fields.useCustomTextColor]: boolean;
        [fields.textColor]: string;
    } & HasResponsive; // Foundation
    extendedStyles?: LinkListStyles;
}

export interface LinkListStyles {
    linkListWrapper?: InjectableCss;
    titleWrapper?: InjectableCss;
    title?: TypographyPresentationProps;
    linkWrapper?: InjectableCss;
    // Starter Custom Code
    horizontalList?: StyledProp;
    horizontalItem?: StyledProp;
    verticalList?: StyledProp;
    verticalItem?: StyledProp;
    titleLink?: LinkPresentationProps;
    linkStyle?: LinkPresentationProps;
    // Foundation
    linkWrapperHorizontal?: InjectableCss;
    linkWrapperVertical?: InjectableCss;
}

export const linkListStyles: LinkListStyles = {
    linkListWrapper: {},
    titleWrapper: {
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};

            /* Store Custom Code - Start */
            ${({ theme }) => contentSpacingStyles(0, 0, theme.design.layout.spacing.base, 0)}
            font-size: ${({ theme }) => theme.design.typography.size.base};

            /* Store Custom Code - End */
        `,
    },
    // Store Removed Code - linkWrapper
    linkWrapperHorizontal: {
        css: css`
            display: inline-block;

            /* Store Custom Code - Start */
            ${contentSpacingStyles(0, pxToRem(10), 0, pxToRem(10), "padding")}
            border-left: 1px solid ${getColor("text")};

            &:first-child {
                border-left: 0;
            }

            /* Store Custom Code - End */
        `,
    },
    linkWrapperVertical: {
        css: css`
            padding: 0 0 ${pxToRem(8)} 0; /* Store Custom Code */
        `,
    },
    linkStyle: {
        css: css`
            ${linkStyles("text", "text", false, true)}/* Store Custom Code */
        `,
    },
    title: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.largest};
        `,
    },
};

const defaultCustomCss = `.list-wrapper {
}

.title-wrapper {
}

.list-title {
}

.links-wrapper {
}

.list-link {
}
`;

export const LinkList: FC<OwnProps> = ({ fields, extendedStyles }) => {
    const links = useGetLinks(fields.links, o => o.fields.destination);
    const titleLink = useGetLink(fields.titleLink);
    const styles = useMergeStyles("linkList", linkListStyles, extendedStyles);

    // Foundation --->
    const alignmentStyles = responsiveCss(
        fields,
        field => css`
            text-align: ${field.alignment || "right"};
            ${styles.linkListWrapper?.css}
        `,
    );
    // <--- Foundation

    // Foundation --->
    const directionStyles = responsiveCss(
        fields,
        field => css`
            ${field.direction === "horizontal" ? styles.linkWrapperHorizontal?.css : styles.linkWrapperVertical?.css};
            ${styles.linkWrapper?.css}
        `,
    );
    // <--- Foundation

    // Foundation --->
    const titleStyles = (): LinkPresentationProps => ({
        ...styles.title,
        css: css`
            ${styles.title?.css}
            ${fields.useCustomTextColor
                ? css`
                      color: ${fields.textColor};
                  `
                : css`
                      color: ${getColor("text")}; /* Store Custom Code */
                  `}
        `,
    });

    const routerLinkStyles = (): LinkPresentationProps => ({
        ...styles.linkStyle,
        css: css`
            ${styles.linkStyle?.css}
            ${fields.useCustomTextColor
                ? linkStyles(fields.textColor, fields.textColor, false, false)
                : linkStyles("text", "text", false, true)} /* Store Custom Code */
        `,
    });
    // <--- Foundation

    const customCssWrapper = {
        css: css`
            ${alignmentStyles} /* Foundation */
            ${fields.customCSS}
        `,
    };

    return (
        <StyledWrapper {...customCssWrapper}>
            {/* Foundation */}
            {titleLink.url ? (
                <StyledWrapper {...styles.titleWrapper}>
                    <Link href={titleLink.url} {...routerLinkStyles()}>
                        {fields.title || titleLink.title}
                    </Link>
                </StyledWrapper>
            ) : fields.title ? (
                <StyledWrapper {...styles.titleWrapper}>
                    <Typography as="h3" {...titleStyles()}>
                        {fields.title}
                    </Typography>
                </StyledWrapper>
            ) : null}
            {/* Foundation */}
            {links.map(
                // Foundation --->
                (link, index) =>
                    link?.url && (
                        // eslint-disable-next-line react/no-array-index-key
                        <StyledWrapper key={index} css={directionStyles}>
                            <Link
                                href={link.url}
                                target={fields.links[index].fields.openInNewWindow ? "_blank" : ""}
                                // Foundation
                                {...routerLinkStyles()}
                            >
                                {fields.links[index].fields.overriddenTitle || link.title}
                            </Link>
                        </StyledWrapper>
                    ),
                // <--- Foundation
            )}
        </StyledWrapper>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const advancedTab = {
    displayName: "Advanced",
    sortOrder: 1,
};

const widgetModule: WidgetModule<FoundationFieldDefinition /* Foundation */> = {
    component: LinkList,
    definition: {
        group: "Basic",
        icon: "ax-link-list",
        fieldDefinitions: [
            // Foundation --->
            ...fieldDefinitionBuilder([
                {
                    name: fields.direction,
                    editorTemplate: "DropDownField",
                    defaultValue: "vertical",
                    fieldType: "General",
                    options: [
                        {
                            displayName: "Vertical",
                            value: "vertical",
                        },
                        {
                            displayName: "Horizontal",
                            value: "horizontal",
                        },
                    ],
                    hideEmptyOption: true,
                    tab: basicTab,
                },
                {
                    name: fields.alignment,
                    editorTemplate: "DropDownField",
                    defaultValue: "left",
                    fieldType: "General",
                    options: [
                        {
                            displayName: "Left",
                            value: "left",
                        },
                        {
                            displayName: "Center",
                            value: "center",
                        },
                        {
                            displayName: "Right",
                            value: "right",
                        },
                    ],
                    hideEmptyOption: true,
                    tab: basicTab,
                },
            ]),
            // <--- Foundation
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "Contextual",
                tab: basicTab,
            },
            {
                fieldType: "Contextual",
                name: fields.titleLink,
                displayName: "Title Link",
                editorTemplate: "LinkField",
                defaultValue: { type: "Page", value: "" },
                tab: basicTab,
            },
            // Foundation --->
            {
                name: fields.useCustomTextColor,
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
            {
                name: fields.textColor,
                displayName: "Text color",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                fieldType: "General",
                isVisible: (item: HasFields) => item.fields.useCustomTextColor,
            },
            {
                name: fields.textColor,
                displayName: "Text color",
                editorTemplate: "ColorPickerField",
                defaultValue: "",
                fieldType: "General",
                isVisible: (item: HasFields) => item.fields.useCustomTextColor,
            },
            // <--- Foundation
            {
                name: fields.links,
                editorTemplate: "ListField",
                getDisplay: (item: HasFields, state) => {
                    const {
                        destination: { type, value },
                        overriddenTitle,
                    } = item.fields;
                    if (overriddenTitle) {
                        return overriddenTitle;
                    }
                    if (type === "Page") {
                        const link = getPageLinkByNodeId(state, value);
                        return link?.title;
                    }
                    if (type === "Category") {
                        let displayValue = "";
                        const categories = (state as any).pageEditor.categories;
                        if (!categories) {
                            displayValue = "Loading...";
                        } else {
                            const matchingCategories = categories.filter((o: { id: string }) => o.id === value);
                            if (matchingCategories.length === 0) {
                                displayValue = "Unknown";
                            } else {
                                displayValue = matchingCategories[0].shortDescription;
                            }
                        }

                        return displayValue;
                    }
                    if (type === "Url") {
                        return value;
                    }
                    return value;
                },
                defaultValue: [],
                fieldType: "Contextual",
                fieldDefinitions: [
                    {
                        name: "destination",
                        editorTemplate: "LinkField",
                        defaultValue: {
                            value: "",
                            type: "Page",
                        },
                        isRequired: true,
                    },
                    {
                        name: "overriddenTitle",
                        displayName: "Title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "openInNewWindow",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                ],
                tab: basicTab,
            },
            {
                name: fields.customCSS,
                displayName: "Custom CSS",
                editorTemplate: "CodeField",
                fieldType: "General",
                tab: advancedTab,
                defaultValue: defaultCustomCss,
                isVisible: (item, shouldDisplayAdvancedFeatures) => !!shouldDisplayAdvancedFeatures,
                validate: value => {
                    if (value === undefined || value === null) {
                        return "";
                    }

                    const result = cssLinter.parse(value, { silent: true });
                    if (result?.stylesheet?.parsingErrors) {
                        // the error output at this time only has room for one line so we just show the first error
                        return result.stylesheet.parsingErrors.length <= 0
                            ? ""
                            : result.stylesheet.parsingErrors.map(error => `${error.reason} on line ${error.line}`)[0];
                    }

                    return "Unable to parse Css";
                },
                options: {
                    mode: "css",
                    lint: true,
                    autoRefresh: true,
                },
            },
        ],
    },
};

export default widgetModule;
